import 'owl.carousel';

export default function SliderReview($DOM, classes) {
	const $container = $('.slider-review');

	if(!$container.length) {
		return false;
	}

	$container.each(function(){ 
		const $this = $(this);

		$this.find('.' + classes.OwlContainer).owlCarousel({
			loop: true,
			margin: 29,
			dots: false,
			nav: true,
			navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				}
			}
		});
	});
}